/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { URGENT_CARE_SUGGESTION } from 'utils/constants';
import EmergencyCareDescription from './EmergencyCareDescription';

const EMERGENCY_CARE_TITLE = 'Try Urgent Care';
const EMERGENCY_CARE_DESCRIPTION = <EmergencyCareDescription />;

export const specialtySuggestionMap = {};

/* **************** */
/* subspecialties */
/* **************** */
const EMERGENCY_CARE_CLINIC_SSID = 549;
const EMERGENCY_CARE_GENERAL_ACUTE_SSID = 449;
const EMERGENCY_CARE_CRITICAL_ACCESS_SSID = 451;

const emergencySuggestion = {
  title: EMERGENCY_CARE_TITLE,
  description: EMERGENCY_CARE_DESCRIPTION,
  suggestion: URGENT_CARE_SUGGESTION,
};
export const subspecialtySuggestionMap = {
  [EMERGENCY_CARE_CLINIC_SSID]: emergencySuggestion,
  [EMERGENCY_CARE_GENERAL_ACUTE_SSID]: emergencySuggestion,
  [EMERGENCY_CARE_CRITICAL_ACCESS_SSID]: emergencySuggestion,
};
